import { Component, OnInit } from '@angular/core';
import { UserService } from '../../services/user/user.service';
import { AppearanceService } from '../../services/appearance/appearance.service';
import { ModalController } from '@ionic/angular';
import { JobService } from 'src/app/services/job/job.service';
import { AlertModel } from 'src/app/models/alert.model';
import { Constants } from 'src/app/constants/constants';
import { AssetService } from 'src/app/services/asset/asset.service';
import { ClientService } from 'src/app/services/client/client.service';
import { ObservationModel } from 'src/app/models/observation.model';
import { RemedialModel } from 'src/app/models/remedial.model';


@Component({
  selector: 'modal-power-alert',
  templateUrl: './modal-power-alert.component.html',
  styleUrls: ['./modal-power-alert.component.scss'],
})
export class ModalPowerAlertComponent implements OnInit {

  newObservation = new ObservationModel();
  infoError: boolean = false;

  providerRef: string;
  closeAllLocationAlerts: boolean;

  assetUid: any;
  locationUid: any;
  locationName: string;

  constructor(public appearanceService: AppearanceService, private assetService: AssetService,
   public userService: UserService, public modalControllerTwo: ModalController, 
   public jobService: JobService, private clientService: ClientService) {

  }


  ngOnInit() 
  {

  }


  ionViewWillEnter()
  {
    if (!this.assetUid || !this.locationUid)
    {
      this.appearanceService.presentToast("Missing Asset or Location info", Constants.TOAST_ERROR);
      this.closeModal(null);
      return;
    }

    this.newObservation = new ObservationModel();
    this.newObservation.chosenRemedials = new Array<RemedialModel>();
    this.newObservation.observationInfo = "";

    this.providerRef = "";
    this.closeAllLocationAlerts = false;
  }


  ionViewWillLeave()
  {

  }


  closeModal(returnData = null)
  {
    this.modalControllerTwo.dismiss(returnData, null, 'PowerIssueModal');
  }


  removePowerAlert()
  {
    var payload = {
      assetUid: this.assetUid,
      clientUid: this.clientService.getClientUid(),
      organisationUid: this.clientService.getOrganisationUid(),
      locationUid: this.locationUid,
      providerRef: this.providerRef,
      closeAllLocationAlerts: this.closeAllLocationAlerts
    }

    this.appearanceService.showLoading("Please wait...").then(() => {

      this.assetService.removeAssetPowerIssue(payload).subscribe(response => {

        this.appearanceService.dismissLoading();

        if (response.Success)
        {
          var returnData = { reload: true };
          this.modalControllerTwo.dismiss(returnData, null, 'PowerIssueModal');
        }
        else
        {
          this.appearanceService.presentToast(response.Message, Constants.TOAST_ERROR);
        }
      },
      err => {

        this.appearanceService.dismissLoading();
        this.appearanceService.presentToast(err, Constants.TOAST_ERROR);

      });
    });
  }
}
